import type { ReactNode } from 'react';

export interface PhotoSectionLayoutProps {
  phone: boolean;
  /** Width of the left column when there is room for two columns. */
  leadWidth: number;
  /** The photo (or crop box) and whatever belongs directly under it. */
  lead: ReactNode;
  /** The short explanation shown beside the photo, or above it on a phone. */
  intro: ReactNode;
  children: ReactNode;
}

const COLUMN = { display: 'flex', flexDirection: 'column', gap: 12 } as const;

/** Photo on the left and details on the right; stacked on a phone. */
export function PhotoSectionLayout({
  phone,
  leadWidth,
  lead,
  intro,
  children,
}: PhotoSectionLayoutProps) {
  if (phone) {
    return (
      <div style={{ ...COLUMN, paddingTop: 14 }}>
        {intro}
        {lead}
        {children}
      </div>
    );
  }
  return (
    <div style={{ paddingTop: 14, display: 'flex', gap: 20, alignItems: 'flex-start' }}>
      <div style={{ width: leadWidth, flex: '0 0 auto' }}>{lead}</div>
      <div style={{ ...COLUMN, flex: 1, minWidth: 0 }}>
        {intro}
        {children}
      </div>
    </div>
  );
}
